export default {
      id: "icon-tasting-and-talk-usage",
      viewBox: "0 0 41.07 48.62",
      url: __webpack_public_path__ + "icons.ea799da449d35b9cdeaf2018df08853f.svg#icon-tasting-and-talk",
      toString: function () {
        return this.url;
      }
    }